// LAZY LOADING IMAGES

document.addEventListener("DOMContentLoaded", () => {

    const lazyImages = document.querySelectorAll(
        'img.lazy-image[data-src]'
    );

    if (!lazyImages.length) return;

    if (!("IntersectionObserver" in window)) {
        lazyImages.forEach(loadImage);
        return;
    }

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach(entry => {

                if (!entry.isIntersecting) return;

                const img = entry.target;

                loadImage(img);

                observer.unobserve(img);
            });
        }, {
            rootMargin: "300px 0px",
            threshold: 0.01
        }
    );

    lazyImages.forEach(img => observer.observe(img));

    function loadImage(img) {

        if (!img.dataset.src) return;

        const realSrc = img.dataset.src;

        const tempImage = new Image();

        tempImage.decoding = "async";

        tempImage.onload = () => {

            img.src = realSrc;

            if (img.dataset.srcset) {
                img.srcset = img.dataset.srcset;
            }

            img.classList.add("loaded");

            delete img.dataset.src;
            delete img.dataset.srcset;
        };

        tempImage.src = realSrc;
    }
});


document.addEventListener('click', function(e) {
    var btn = e.target.closest('.sbtn-copy');
    if (!btn) return;
    var url = btn.dataset.copyUrl;
    var orig = btn.innerHTML;
    navigator.clipboard.writeText(url).then(function() {
        btn.textContent = 'Copied';
        setTimeout(function() { btn.innerHTML = orig; }, 2000);
    });
});



//FIXED HEADER

const navbar = document.querySelector('.header-section');
const navbarOffset = navbar.offsetTop;
const navbarHeight = navbar.offsetHeight;
const placeholder = document.createElement('div');
placeholder.style.display = 'none';
placeholder.style.height = navbarHeight + 'px';
navbar.parentNode.insertBefore(placeholder, navbar.nextSibling);

window.addEventListener('scroll', () => {
    if (window.scrollY >= navbarOffset) {
        navbar.classList.add('menufixed');
        placeholder.style.display = 'block';
    } else {
        navbar.classList.remove('menufixed');
        placeholder.style.display = 'none';
    }
});


// ===================================================================
// ===================================================================
// PAYWALL
// ===================================================================
// ===================================================================

//CLOSE PAYWALL MODAL ON CLOSE BUTTON CLICK
if (document.querySelector('.pw-close')) {
    document.querySelector('.pw-close').addEventListener('click', function() {
        document.querySelector('.paywall-modal').classList.remove('active');
    });
}

//SHOW PAYWALL AFTER 60% SCROLL DEPTH
if (document.querySelector('.paywall-modal')) {
    function handlePaywallScroll() {
        var scrolled = window.scrollY + window.innerHeight;
        var totalHeight = document.documentElement.scrollHeight;
        var percent = (scrolled / totalHeight) * 100;

        if (percent >= 60) {
            document.querySelector('.paywall-modal').classList.add('active');
            window.removeEventListener('scroll', handlePaywallScroll);
        }
    }
    window.addEventListener('scroll', handlePaywallScroll);
}


// ===================================================================
// ===================================================================
// SEARCH OVERLAY
// ===================================================================
// ===================================================================
const searchOverlay = document.querySelector('.search-overlay');
const searchBox = document.querySelector('.search-box');
const closeBtn = document.querySelector('.search-overlay .close');

searchBox.addEventListener('click', function(e) {
    e.preventDefault();
    searchOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    searchOverlay.querySelector('.search-input').focus();
});

closeBtn.addEventListener('click', function(e) {
    e.preventDefault();
    searchOverlay.classList.remove('active');
    document.body.style.overflow = '';
});

document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && searchOverlay.classList.contains('active')) {
        searchOverlay.classList.remove('active');
        document.body.style.overflow = '';
    }
});


// ===================================================================
// ===================================================================
// SEARCH PAGE FILTER
// ===================================================================
// ===================================================================

document.addEventListener('DOMContentLoaded', init);

function init() {
    initTypeSelector();
    initRangeSlider();
    initResetButton();
    initKeyboardNav();
    initAutoSubmit();
}

function initTypeSelector() {
    document.querySelectorAll('#type-list .type-row').forEach(function(row) {
        row.addEventListener('click', function() {
            selectType(this);
        });
    });
}

window.selectType = function(el, typeKey) {
    document.querySelectorAll('#type-list .type-row').forEach(function(r) {
        r.classList.remove('active');
        r.setAttribute('aria-selected', 'false');
    });
    el.classList.add('active');
    el.setAttribute('aria-selected', 'true');

    const input = document.getElementById('active-type');
    if (input && typeKey) input.value = typeKey;
    const form = document.getElementById('search-filter-form');
    if (form) form.submit();
};

function initRangeSlider() {
    const slider = document.getElementById('readSlider');
    if (slider) updateSlider(slider);
}

window.updateSlider = function(input) {
    const min = Number(input.min) || 0;
    const max = Number(input.max) || 100;
    const val = Number(input.value);
    const pct = ((val - min) / (max - min)) * 100 + '%';
    input.style.background =
        'linear-gradient(to right, var(--accent) ' + pct + ', var(--rule) ' + pct + ')';
};

function initResetButton() {}

window.resetFilters = function() {
    document.querySelectorAll('#search-filter-form input[type="checkbox"]').forEach(
        function(cb) { cb.checked = false; }
    );
    document.querySelectorAll('#search-filter-form input[type="radio"]').forEach(
        function(r) { r.checked = r.value === ''; }
    );
    const slider = document.getElementById('readSlider');
    if (slider) {
        slider.value = slider.max;
        updateSlider(slider);
    }
    const rows = document.querySelectorAll('#type-list .type-row');
    rows.forEach(function(r, i) {
        r.classList.toggle('active', i === 0);
        r.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
    });
    const input = document.getElementById('active-type');
    if (input) input.value = 'articles';
    const form = document.getElementById('search-filter-form');
    if (form) form.submit();
};

function initKeyboardNav() {
    document.querySelectorAll('.type-row').forEach(function(row) {
        row.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                row.click();
            }
        });
    });
    document.querySelectorAll('.trend-item').forEach(function(el) {
        el.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                const link = el.querySelector('a');
                if (link) link.click();
            }
        });
    });
}

function initAutoSubmit() {
    const form = document.getElementById('search-filter-form');
    if (!form) return;
    let timer;

    function debounce(fn, delay) {
        clearTimeout(timer);
        timer = setTimeout(fn, delay);
    }

    form.querySelectorAll('input[type="checkbox"]').forEach(function(cb) {
        cb.addEventListener('change', function() { form.submit(); });
    });
    form.querySelectorAll('input[type="radio"]').forEach(function(r) {
        r.addEventListener('change', function() { form.submit(); });
    });
    const slider = document.getElementById('readSlider');
    if (slider) {
        slider.addEventListener('input', function() {
            updateSlider(this);
            debounce(function() { form.submit(); }, 600);
        });
    }
}


// ===================================================================
// ===================================================================
// POST FILTERING IN AUTHOR PAGE
// ===================================================================
// ===================================================================
if (typeof authorPageData !== 'undefined') {

    const { ajaxUrl, nonce, authorId, i18n } = authorPageData;

    const tabList = document.querySelector('.categories-tab ul');
    const articlesWrap = document.getElementById('author-articles');
    const paginationWrap = document.querySelector('.pagination-container');

    if (tabList && articlesWrap) {

        let currentCat = Number(new URLSearchParams(location.search).get('cat_id')) || 0;
        let currentPage = Number(new URLSearchParams(location.search).get('paged')) || 1;
        let isFetching = false;

        function setLoading(on) {
            articlesWrap.classList.toggle('is-loading', on);
            tabList.querySelectorAll('a').forEach(function(a) {
                a.setAttribute('aria-busy', on ? 'true' : 'false');
            });
        }

        function renderPagination(links) {
            if (!paginationWrap) return;

            if (!links || !links.length) {
                paginationWrap.style.display = 'none';
                return;
            }

            const ul = paginationWrap.querySelector('ul.pagination');
            if (ul) {
                ul.innerHTML = links
                    .map(function(link) { return '<li>' + link + '</li>'; })
                    .join('');
            }

            paginationWrap.style.display = '';
        }

        function fetchArticles(catId, paged) {
            if (isFetching) return;
            isFetching = true;
            setLoading(true);

            const body = new URLSearchParams({
                action: 'author_page_filter',
                nonce: nonce,
                author_id: authorId,
                cat_id: catId,
                paged: paged,
            });

            fetch(ajaxUrl, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
                    body: body.toString(),
                })
                .then(function(res) {
                    if (!res.ok) throw new Error('Network error');
                    return res.json();
                })
                .then(function(json) {
                    if (!json.success) {
                        // FIX: safe fallback instead of optional chaining
                        throw new Error((json.data && json.data.message) ? json.data.message : 'Unknown error');
                    }
                    articlesWrap.innerHTML = json.data.html;
                    renderPagination(json.data.pageLinks);
                    bindPaginationClicks();
                    articlesWrap.setAttribute('aria-live', 'polite');
                    articlesWrap.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                })
                .catch(function() {
                    articlesWrap.innerHTML = '<p class="no-posts">' + i18n.error + '</p>';
                })
                .finally(function() {
                    isFetching = false;
                    setLoading(false);
                });
        }

        function handlePaginationClick(e) {
            const link = e.target.closest('a.page-numbers');
            if (!link) return;

            e.preventDefault();

            const url = new URL(link.href, location.href);
            const paged = Number(url.searchParams.get('paged')) || 1;

            currentPage = paged;

            const newUrl = buildUrl(currentCat, currentPage);
            history.pushState({ catId: currentCat, paged: currentPage }, '', newUrl);

            fetchArticles(currentCat, currentPage);
        }

        function bindPaginationClicks() {
            if (!paginationWrap) return;
            paginationWrap.removeEventListener('click', handlePaginationClick);
            paginationWrap.addEventListener('click', handlePaginationClick);
        }

        function buildUrl(catId, paged) {
            const params = new URLSearchParams();
            if (catId) params.set('cat', catId);
            if (paged > 1) params.set('paged', paged);
            const qs = params.toString();
            return location.pathname + (qs ? '?' + qs : '');
        }

        function syncActiveTabs(catId) {
            tabList.querySelectorAll('a').forEach(function(a) {
                const url = new URL(a.href, location.href);
                const tabCat = Number(url.searchParams.get('cat')) || 0;
                a.classList.toggle('active', tabCat === catId);
            });
        }

        tabList.addEventListener('click', function(e) {
            const link = e.target.closest('a');
            if (!link) return;

            const url = new URL(link.href, location.href);
            const catId = Number(url.searchParams.get('cat')) || 0;

            if (catId === currentCat) {
                e.preventDefault();
                return;
            }

            e.preventDefault();

            currentCat = catId;
            currentPage = 1;

            syncActiveTabs(catId);
            history.pushState({ catId: catId, paged: 1 }, '', buildUrl(catId, 1));
            fetchArticles(catId, 1);
        });

        window.addEventListener('popstate', function(e) {
            const state = e.state || {};
            currentCat = state.catId || 0;
            currentPage = state.paged || 1;
            syncActiveTabs(currentCat);
            fetchArticles(currentCat, currentPage);
        });

        history.replaceState({ catId: currentCat, paged: currentPage }, '', location.href);
        bindPaginationClicks();
    }
}


// ===================================================================
// ===================================================================
// TAG PAGE LOAD MORE
// ===================================================================
// ===================================================================

const load_more_tag_articles_btn = document.getElementById('load-more-btn');

if (load_more_tag_articles_btn && typeof themeAjax !== 'undefined') {
    let currentPage = parseInt(load_more_tag_articles_btn.dataset.page, 10) || 1;
    const maxPages = parseInt(load_more_tag_articles_btn.dataset.maxPages, 10) || 1;
    const tagId = parseInt(load_more_tag_articles_btn.dataset.tagId, 10) || 0;
    const grid = document.getElementById('articles-grid');

    load_more_tag_articles_btn.addEventListener('click', function() {
        if (currentPage >= maxPages) return;
        load_more_tag_articles_btn.disabled = true;
        load_more_tag_articles_btn.textContent = themeAjax.loading || 'Loading…';
        load_more_tag_articles_btn.setAttribute('aria-busy', 'true');

        const body = new URLSearchParams({
            action: 'theme_load_more_tag',
            nonce: themeAjax.nonce,
            tag_id: tagId,
            page: currentPage,
        });

        fetch(themeAjax.ajaxUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
                body: body.toString(),
            })
            .then((res) => {
                if (!res.ok) throw new Error('Network error');
                return res.json();
            })
            .then((data) => {
                // FIX: safe fallback instead of optional chaining
                if (!data.success) throw new Error((data.data && data.data.message) ? data.data.message : 'Unknown error');

                if (data.data.html) {
                    const tmp = document.createElement('div');
                    tmp.innerHTML = data.data.html;

                    const newCards = [...tmp.children];
                    newCards.forEach((card) => grid.appendChild(card));
                    if (newCards[0]) newCards[0].focus({ preventScroll: false });
                }

                currentPage++;
                load_more_tag_articles_btn.dataset.page = currentPage;

                // FIX: was referencing undefined `btn` — corrected to load_more_tag_articles_btn
                if (data.data.no_more || currentPage >= maxPages) {
                    load_more_tag_articles_btn.remove();
                } else {
                    load_more_tag_articles_btn.disabled = false;
                    load_more_tag_articles_btn.textContent = themeAjax.loadMore || 'Load More Stories';
                    load_more_tag_articles_btn.removeAttribute('aria-busy');
                }
            })
            .catch((err) => {
                console.error('[theme] load-more error:', err);
                // FIX: was referencing undefined `btn` — corrected to load_more_tag_articles_btn
                load_more_tag_articles_btn.disabled = false;
                load_more_tag_articles_btn.textContent = themeAjax.loadMore || 'Load More Stories';
                load_more_tag_articles_btn.removeAttribute('aria-busy');
            });
    });
}


function setActive(el) {
    document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
    el.classList.add('active');
}




// ===================================================================
// ===================================================================
// NEWS FILTER
// ===================================================================
// ===================================================================

const filterBtns = document.querySelectorAll('.filter-btn');
// FIX: Renamed from `items` to `newsItems` to avoid variable name conflict
const newsItems = document.querySelectorAll('.news-item');

filterBtns.forEach(btn => {
    btn.addEventListener('click', () => {
        filterBtns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        const filter = btn.dataset.filter;

        let visibleIndex = 1;
        // FIX: updated reference from `items` to `newsItems`
        newsItems.forEach(item => {
            const cat = item.dataset.category;
            const show = filter === 'all' || cat === filter;
            const hr = item.nextElementSibling;

            if (show) {
                item.style.display = 'flex';
                item.querySelector('.item-number').textContent = String(visibleIndex).padStart(2, '0');
                visibleIndex++;
                if (hr) hr.style.display = '';
            } else {
                item.style.display = 'none';
                if (hr) hr.style.display = 'none';
            }
        });
    });
});


// ===================================================================
// ===================================================================
// HEADER NAV RESPONSIVE
// ===================================================================
// ===================================================================

function checkWidth() {
    const el = document.getElementById('headerNavCollapse');
    if (window.innerWidth >= 1200) {
        el.classList.add('show');
    } else {
        if (!el.classList.contains('manually-open')) {
            el.classList.remove('show');
        }
    }
}

document.getElementById('headerNavCollapse').addEventListener('show.bs.collapse', () => {
    document.getElementById('headerNavCollapse').classList.add('manually-open');
});
document.getElementById('headerNavCollapse').addEventListener('hide.bs.collapse', () => {
    document.getElementById('headerNavCollapse').classList.remove('manually-open');
});

checkWidth();
window.addEventListener('resize', checkWidth);


//ADD ACCESSIBILITY LABEL TO ONE SIGNAL BUTTON
const observer = new MutationObserver((mutations, obs) => {
    const osButton = document.querySelector('.onesignal-bell-launcher-button');
    if (osButton) {
        osButton.setAttribute('aria-label', 'Subscribe to Nairametrics Notification');
        obs.disconnect();
    }
});

// Watch the entire document for the element to appear
observer.observe(document.body, {
    childList: true,
    subtree: true
});



function addAriaLabel() {
    const logoLink = document.querySelector("a.mglogo-link");

    if (logoLink && !logoLink.hasAttribute("aria-label")) {
        logoLink.setAttribute("aria-label", "Mgrid News");
        console.log('Added aria-label="Mgrid News" to .mglogo-link');
        return true;
    }

    return false;
}

if (!addAriaLabel()) {
    const observer = new MutationObserver(() => {
        if (addAriaLabel()) {
            observer.disconnect();
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}